import { forwardRef } from 'react'
import classnames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// Mirrors @wetu/design-system-components Button (primary, secondary and outline types).
const Button = forwardRef(({ buttonType = 'primary', icon, iconPosition = 'left', className, children, type = 'button', ...props }, ref) => {
    const iconElement = icon ? <FontAwesomeIcon icon={icon} className="ds-button__icon" aria-hidden="true" /> : null

    return (
        <button ref={ref} type={type} className={classnames('ds-button', `ds-button--${buttonType}`, className)} {...props}>
            {iconPosition !== 'right' && iconElement}
            {children}
            {iconPosition === 'right' && iconElement}
        </button>
    )
})

Button.displayName = 'Button'

export default Button
